import { useNavigation } from 'react-router';
import { useFetchers } from '@remix-run/react';

export default function useLoading(): boolean {
  const navigation = useNavigation();
  const fetchers = useFetchers();

  return navigation.state !== 'idle' || fetchers.filter((f) => f.state !== 'idle').length > 0;
}
